export { default } from './ButtonRemoveProductsFromShoppingCart';
